export default function Front() {
  return (
    <section className="z-10 py-4">
      <div className="w-[94%] sm:w-11/12 mx-auto">
        {/* Container: 
            - Tall (580px) on mobile to make it look big.
            - Auto height on desktop to fit the wide image perfectly.
        */}
        <div className="rounded-2xl sm:rounded-3xl relative w-full min-h-[380px] sm:min-h-fit overflow-hidden bg-[#f5e6f0]">
          
          {/* MOBILE IMAGE: The portrait version (image_0.png)
              - Visible only on mobile (block sm:hidden)
              - object-cover ensures it fills the 580px height beautifully
          */}
          <img
            src="/VIDEO2.png" 
            alt="Hook hero mobile"
            className=" w-full object-cover block sm:hidden"
          />

          {/* DESKTOP IMAGE: The wide version (VIDEO.png)
              - Hidden on mobile, visible on desktop (hidden sm:block)
              - relative/h-auto allows the container to follow the image's shape
          */}
          <img
            src="/VIDEO.png"
            alt="Hook hero desktop"
            className="hidden sm:block w-full h-auto object-contain relative"
          />

          {/* Buttons: 
              - Bottom-left alignment that adjusts slightly between mobile and desktop
          */}
          <div className="absolute bottom-[12%] sm:bottom-[16%] left-[8%] sm:left-[6%] flex items-center flex-wrap gap-4">
             {/* Your buttons go here */}
          </div>

        </div>
      </div>
    </section>
  );
}